export default "__VITE_PUBLIC_ASSET__02050522__"